import React, {Component, Fragment} from "react";
import League from "./League";
import _ from "lodash";

class Leagues extends Component {
	render() {
		const {sport, leagues, selected, checkHandler} = this.props;
		const leaguesBySport = leagues.filter((league) => {return league.sport_id === sport.id && +league.type === 0});

		const topLeagues = leaguesBySport.filter((league) => {return +league.order !== 0});
		const otherLeagues = leaguesBySport.filter((league) => {return +league.order === 0});
		const sortedTopLeagues = _.sortBy(topLeagues, l => +l.order).reverse();

		const isNeedTop = sortedTopLeagues.length > 0;

		const top = sortedTopLeagues.map((league) =>
			<League key={`league-${league.id}`}
			        league={league}
			        isChecked={league.id in selected}
			        checkHandler={checkHandler}/>);

		const line = otherLeagues.map((league) =>
			<League key={`league-${league.id}`}
			        league={league}
			        isChecked={league.id in selected}
			        checkHandler={checkHandler}/>);

		const long = leagues.filter((league) => {return league.sport_id === sport.id && parseInt(league.type) === 1}).map((league) => {
			return <League key={`league-${league.id}`} league={league} isChecked={league.id in selected} checkHandler={checkHandler}/>
		});

		const longCaption = <div className="tr long-caption">
			<div className="td favorite"></div>
			<div className="td players">Долгосрочные</div>
		</div>;

		return (
			<div className="tbody">
				{top}

				{isNeedTop &&
				<div className="tr top-row">
					<div className="td favorite">
						<div className="row"></div>
					</div>
					<div className="td players">
						<div className="row"></div>
					</div>
				</div>}

				{line}

				{long.length > 0 && longCaption}
				{long}
			</div>
		);
	}
}

export default Leagues;


// WEBPACK FOOTER //
// ./src/app/pages/LineSelect/modules/Leagues.js